import { ticksToMs } from '../../../utils/utils';

const MS_PER_DAY = 24 * 60 * 60 * 1000;
const DAYS_14_MS = 14 * MS_PER_DAY;
const DAYS_7_MS = 7 * MS_PER_DAY;
const DAYS_1_MS = 1 * MS_PER_DAY;

/** Neutral share icon: theme maps blue-dark → near-white in dark mode (text-white is surface). */
const NEUTRAL_ICON_CLASS = 'text-blue-dark';

export type ShareExpirationTooltipMode = 'shared' | 'expiresOn' | 'shareExpiredOn';

export type ShareExpirationIconState = {
  colorClass: string;
  tooltipMode: ShareExpirationTooltipMode;
};

/**
 * Color + tooltip mode for the shared-file icon from share expiration ticks.
 */
export function getShareExpirationIconState(
  ticks: number | null | undefined,
  nowMs: number,
): ShareExpirationIconState {
  if (ticks == null || ticks <= 0) {
    return { colorClass: NEUTRAL_ICON_CLASS, tooltipMode: 'shared' };
  }

  const msLeft = ticksToMs(ticks) - nowMs;

  if (msLeft < 0) {
    return { colorClass: 'text-red-dark', tooltipMode: 'shareExpiredOn' };
  }
  if (msLeft <= DAYS_1_MS) {
    return { colorClass: 'text-yellow-dark', tooltipMode: 'expiresOn' };
  }
  if (msLeft <= DAYS_7_MS) {
    // ponytail: no orange token in theme; Tailwind default orange-500
    return { colorClass: 'text-orange-500', tooltipMode: 'expiresOn' };
  }
  if (msLeft <= DAYS_14_MS) {
    return { colorClass: 'text-green-dark', tooltipMode: 'expiresOn' };
  }
  return { colorClass: NEUTRAL_ICON_CLASS, tooltipMode: 'expiresOn' };
}
